import React from 'react'
import companies from '../../assets/icons/companies.svg'
import '../../assets/css/tags.css'
const AdminTag = () => {
  return (
    <img src={companies}  
      className='administator'
      onClick={(e) => e.stopPropagation()}
      />
  )
}

export default AdminTag